export default __webpack_public_path__ + "static/media/480_business03-en-mobile.c4a65a61.png";